import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { Subscription, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Message, SpinnerService } from "shared-components";
import { GestionService } from "../../../services/gestion.service";

@Component({
    selector: 'app-imagen-color-denominacion',
    templateUrl: './imagen-color-denominacion.component.html',
})
export class ImagenColorDenominacionComponent implements OnInit, OnDestroy {
    private readonly destroy$ = new Subject<void>();

    @Input() denominacionId;
    @Input() desDenominacion;

    @Output() refresh = new EventEmitter<boolean>();
    @Output() mensaje = new EventEmitter<string>();

    public form: UntypedFormGroup;
    public colorDisplay = '#ffffff';
    public isDragging = false;
    public selected64Image: string | null = null;
    public selectedFile: File | null = null;
    public currentFile = {
        format: null,
        name: null
    }

    public showError: boolean;
    public mensajes = new Array<Message>();

    constructor(
        private readonly _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _gestionService: GestionService
    ) {}

    ngOnInit(): void {
        this.form = this._fb.group({
            color: ['#ffffff']
        });

        this.form.get('color')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => {
            this.colorDisplay = value;
        });

        this.getCurrentImageAndColor();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public close() {
        this.refresh.emit(false);
    }

    private getCurrentImageAndColor() {
        this._spinnerService.showSpinner();
        this._gestionService.getDenominacionImagenColor(this.denominacionId).toPromise().finally(() => {
        this._spinnerService.hideSpinner();
        }).then((resp) => {
            resp.certificado_HexColor ? this.form.get('color')?.patchValue(resp.certificado_HexColor) : this.form.get('color')?.patchValue('#ffffff');
            this.currentFile.name = resp.certificado_RefArchivo;
            this.currentFile.format = resp.certificado_RefArchivo?.split('.').pop().toLowerCase() || '';
            this.selected64Image = resp.certificado_Archivo ? `data:image/${this.currentFile.format};base64,${resp.certificado_Archivo}` : null;
        }, (error) => {
            this.pushMessage('global.error.noResponse');
        });
    }

    public onFileSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files[0]) {
            this.loadFile(input.files[0]);
        }
    }

    public onDragOver(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.isDragging = true;
    }

    public onDragLeave(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.isDragging = false;
    }

    public onDrop(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.isDragging = false;
        const file = event.dataTransfer?.files[0];
        if (file) {
            this.loadFile(file);
        }
    }

    private loadFile(file: File) {
        const allowed = ['image/jpg', 'image/jpeg', 'image/png'];

        if (!allowed.includes(file.type)) return;
        
        this.selectedFile = file;
        const reader = new FileReader();
        reader.onload = (e) => {
            this.selected64Image = e.target?.result as string; // en base64
        };
        reader.readAsDataURL(file);
    }

    public pushMessage(message: string) {
        this.showError = true;
        if (message.includes('.error.')) {
            this.mensajes.push({ class: 'error', message: message });
        } else {
            this.mensajes.push({ class: 'success', message: message });
        }
    }

    public save() {
        if (this.form.get('color')?.value && this.form.get('color')?.value !== '#ffffff'
        && this.selected64Image) {
            const filters = {
                id: this.denominacionId,
                // la imagen (y el nombre) solo se envía si el usuario la inserta por primera vez o la cambia !!
                certificado_Archivo: this.selectedFile?.name ? this.selected64Image.replace(/^data:image\/[a-z]+;base64,/, '') : null,
                certificado_RefArchivo: this.selectedFile?.name || null,
                certificado_HexColor: this.form.get('color')?.value
            };

            this._spinnerService.showSpinner();
            this._gestionService.updateDenominacionImagenColor(filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
            }).then((resp) => {
                this.mensaje.emit('global.success.itemUpdated');
                this.refresh.emit(false);
            }, (error) => {
                this.pushMessage('global.error.noResponse');
            });
        } else {
            this.pushMessage('global.error.imagenColor');
        }
    }
}
